<div class="app-loading modal">
   
    <svg  width="100px" height="100px" viewBox="0 0 160 160">
      <title>{{loadingMessage}}</title>
    <defs>
        <path d="M20.8267,0.3945 C20.8267,0.3945 -0.0003,0.3945 -0.0003,21.2205 L-0.0003,139.1365 C-0.0003,139.1365 -0.0003,159.9645 20.8267,159.9645 L138.7437,159.9645 C138.7437,159.9645 159.5707,159.9645 159.5707,139.1365 L159.5707,21.2205 C159.5707,21.2205 159.5707,0.3945 138.7437,0.3945 L20.8267,0.3945 Z" id="path-1"></path>
        <path d="M117.6731,117.1268 L84.7081,39.4658 C83.9901,37.7758 82.4411,36.6338 80.7261,36.3268 C80.6861,36.3188 80.6451,36.3198 80.6041,36.3128 C80.3331,36.2708 80.0611,36.2388 79.7851,36.2408 C79.5091,36.2388 79.2371,36.2708 78.9661,36.3128 C78.9251,36.3198 78.8841,36.3188 78.8441,36.3268 C77.1291,36.6338 75.5801,37.7758 74.8621,39.4658 L41.8971,117.1268 C40.7841,119.7488 41.9861,122.9108 44.6201,124.0298 C47.2541,125.1478 50.3641,123.8148 51.4771,121.1928 L79.7851,54.5028 L108.0931,121.1928 C109.2061,123.8148 112.3161,125.1478 114.9501,124.0298 C117.5841,122.9108 118.7861,119.7488 117.6731,117.1268" id="path-3"></path>
    </defs>
    <g id="branding/aria/icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon" transform="translate(0.000000, -0.395000)">
            <g id="colours/branding/Mitie-Cyan">
                <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                </mask>
                <use id="Mask" fill="#009FDF" xlink:href="#path-1"></use>
                <g mask="url(#mask-2)" fill="#009FDF" id="Rectangle">
                    <g transform="translate(-12.000000, -11.000000)">
                        <rect x="0" y="0" width="185" height="182"></rect>
                    </g>
                </g>
            </g>
            <mask id="mask-4" fill="white">
                <use xlink:href="#path-3"></use>
            </mask>
            <use id="Fill-31" fill="#FEFEFE" xlink:href="#path-3"></use>
            <g id="colours/branding/Mitie-White" mask="url(#mask-4)" fill="#FFFFFF">
                <g transform="translate(26.000000, 27.000000)" id="Rectangle">
                    <rect x="0" y="0" width="112" height="112"></rect>
                </g>
            </g>
        </g>
    </g>
    </svg>
    <div id="loading-message" class="logo" style="z-index: 1;padding-top: 10px;">
        <span style="background-color: white;">{{ loadingMessage }}</span>
    </div>
  </div>